module.exports = __webpack_public_path__ + "static/media/st_pattys_plinko.12b4e461.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/st_pattys_plinko.png
// module id = 338
// module chunks = 0